export default __webpack_public_path__ + "static/media/no-result.a44ddb6d.png";